module.exports = __webpack_public_path__ + "static/media/delete_hover.ca57934b.svg";